module.exports = __webpack_public_path__ + "static/art1-4b3d19995526091b735392f84023c1b4.jpg";